<template>
  <component :is="tag" :class="className">
    <slot></slot>
  </component>
</template>

<script>
/**
 * @class CardBody
 *
 * @description this component is a wrapper for breadcrumb "panel-body"
 */
export default {
  name: 'CardBody',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    className: {
      type: String,
      default: 'panel-body',
    },
  },
}
</script>
